import { Fancybox } from '@fancyapps/ui';

Fancybox.bind('[data-fancybox]', {
  tpl: {
    closeButton: '<button data-fancybox-close class="base-modal__close"></button>',
  },
});
